var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commit-changes-modal',_vm._g(_vm._b({ref:"modal",attrs:{"loading":_vm.loading},on:{"submit-form":_vm.handleBlobDelete},scopedSlots:_vm._u([{key:"form-fields",fn:function(){return [_c('input',{attrs:{"type":"hidden","name":"_method","value":"delete"}})]},proxy:true}])},'commit-changes-modal',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }